import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ResizableSwappableCard } from "@/components/admin/dashboard/ResizableSwappableCard";
import { D3PieChart, D3ResponsiveContainer } from "../charts/D3ChartUtils";
import { useEnhancedTranslation } from "@/hooks/useEnhancedTranslation";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884D8", "#4CAF50", "#9C27B0"];

interface ContractsDistributionChartProps {
  contractsDistribution: any[];
  rearrangingEnabled: boolean;
  onRemove: (id: string) => void;
  size: 'small' | 'medium' | 'large' | 'xlarge';
  onResize?: (id: string, newSize: 'small' | 'medium' | 'large' | 'xlarge') => void;
}

export function ContractsDistributionChart({
  contractsDistribution,
  rearrangingEnabled,
  onRemove,
  size,
  onResize
}: ContractsDistributionChartProps) {
  const { t } = useEnhancedTranslation();
  
  const formattedData = contractsDistribution.map(item => ({
    name: item.name,
    value: item.value
  }));

  const valueFormatter = (value: number) => {
    return t("dashboard.widgets.contractCount", { value: value });
  };

  return (
    <ResizableSwappableCard
      id="contracts-distribution"
      size={size}
      showHandle={rearrangingEnabled}
      showResizeControl={rearrangingEnabled}
      onRemove={rearrangingEnabled ? onRemove : undefined}
      onResize={rearrangingEnabled && onResize ? (newSize) => onResize("contracts-distribution", newSize) : undefined}
    >
      <CardHeader>
        <CardTitle>{t('dashboard.widgets.contractsByType')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <D3ResponsiveContainer width="100%" height="100%">
            <D3PieChart
              data={formattedData}
              colors={COLORS}
              valueFormatter={valueFormatter}
              showLabels={true}
              donut={true}
            />
          </D3ResponsiveContainer>
        </div>
      </CardContent>
    </ResizableSwappableCard>
  );
}
